import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Location, MeData } from 'src/app/model/Me';
import { Store } from '@ngrx/store';
import * as MeActions from 'src/app/core/header/store/me.actions';
import * as fromApp from 'src/app/store/app.reducer';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-info-profilo',
  templateUrl: './info-profilo.component.html',
  styleUrls: ['./info-profilo.component.scss'],
})
export class InfoProfiloComponent implements OnInit, OnDestroy {
  @Input() me: MeData | null = null;

  public sedi: Location[] | any;
  public addInput: boolean = false;
  public inputNum: any[] = [1];
  public avatarUrl: any;

  constructor(
    private store: Store<fromApp.AppState>,
    private http: HttpClient
  ) {}

  public addSede(): void {
    if (this.addInput) {
      this.inputNum.push(1);
    }
    this.addInput = true;
  }

  public removeSede(index: number): void {
    this.sedi.splice(index, 1);
  }

  private storeSub: Subscription;
  public meStore: MeData | null = null;
  public loading: boolean = false;
  public fullName: string = '';

  onSaveProfile(form: NgForm) {
    console.log('form: ', form.value);
    let fiscalCode = form.value.fiscalCode.toUpperCase();
    form.value.fiscalCode = fiscalCode;
    this.store.dispatch(MeActions.updateMe({ me: form.value }));
  }

  changeAvatar(event: any) {}

  ngOnInit(): void {
    this.storeSub = this.store.select('me').subscribe((me) => {
      this.meStore = me.me;
      this.loading = me.loading;
      this.fullName = `${me.me?.firstName} ${me.me?.lastName}`;
      this.sedi = me.me?.location;
    });
    this.getAvatar();
  }

  getAvatar() {
    // return `${environment.NEW_API}/profile/image`;
    return this.http
      .get(`${environment.NEW_API}/profile/image`, { responseType: 'blob' })
      .subscribe((data: any) => {
        return this.createImageFromBlob(data);
      });
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.avatarUrl = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  ngOnDestroy(): void {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }
}
